function isHighSurrogate(charCode: number): boolean {
	return charCode >= 0xd800 && charCode <= 0xdbff;
}

export function truncateUtf16CodeUnits(
	name: string,
	maxCodeUnits: number,
	opts?: {
		suffix?: string;
		ellipsis?: string;
		trimEndOnTruncate?: boolean;
	}
): string {
	if (!Number.isSafeInteger(maxCodeUnits) || maxCodeUnits < 0) {
		throw new Error('Expected a non-negative length');
	}

	const suffixLength = opts?.suffix ? opts.suffix.length : 0;
	const nameLength = name.length;

	if (nameLength + suffixLength <= maxCodeUnits) {
		if (opts?.suffix) {
			return name + opts.suffix;
		} else {
			return name;
		}
	}

	// We need to truncate...
	const ellipsisLength = opts?.ellipsis ? opts.ellipsis.length : 0;

	let i;
	for (i = maxCodeUnits - ellipsisLength - suffixLength; i >= 0; --i) {
		if (!isHighSurrogate(name.charCodeAt(i - 1))) {
			break;
		}
	}

	if (i < 0) {
		i = 0;
	}

	name = name.slice(0, i);

	if (opts?.trimEndOnTruncate) {
		name = name.trimEnd();
	}

	if (ellipsisLength || suffixLength) {
		return name + (opts?.ellipsis ?? '') + (opts?.suffix ?? '');
	} else {
		return name;
	}
}
